import React from 'react'

const LivestreamEmbed = () => (
  <>
    <div className='embed-responsive embed-responsive-16by9 mb-3'>
      <iframe title='x-change-livestream' src="https://www.youtube.com/embed/sDbW4NNJtwQ"
              frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    </div>
    <iframe title="x-change-livechat"
            className="w-100 d-none"
            height="360"
            frameBorder="0" src="https://www.youtube.com/live_chat?v=sDbW4NNJtwQ&embed_domain=www.schueleraustausch.net"></iframe>
  </>
)

export default LivestreamEmbed
